import React from 'react';
import { useIntegrationRoute } from '../hooks/router/use-integration-route';
import GroupsExalus from '../integrations/exalus/modules/groups';
import GroupsLavva from '../integrations/lavva/modules/groups';
import ActionCreateNameIconExalus from '../integrations/exalus/modules/action-create/pages/name-icon';
import ActionCreateTaskListExalus from '../integrations/exalus/modules/action-create/pages/task-list';
import ActionCreateTaskTypesExalus from '../integrations/exalus/modules/action-create/pages/task-types';
import ActionCreateTaskVariantsExalus from '../integrations/exalus/modules/action-create/pages/task-variants';
import DashboardLavva from '../integrations/lavva/modules/dashboard';
import ActionCreateChannelSettingsExalus from '../integrations/exalus/modules/action-create/pages/channel-settings/channel-settings';
import ActionCreateDeviceVariantsExalus from '../integrations/exalus/modules/action-create/pages/devices-variants';
import ActionListExalus from '../integrations/exalus/modules/action-list';
import ChannelConfigurationExalus from '../integrations/exalus/modules/channel-configuration';
import ChannelDetailsExalus from '../integrations/exalus/modules/channel-details';
import ChannelListExalus from '../integrations/exalus/modules/channel-list';
import ChannelsVisibilityExalus from '../integrations/exalus/modules/channels-visiblity';
import DeviceDetailsExalus from '../integrations/exalus/modules/device-details';
import DeviceListExalus from '../integrations/exalus/modules/device-list';
import DeviceListProvider from '../integrations/exalus/modules/device-list/context';
import GroupSortChannelsExalus from '../integrations/exalus/modules/group-sort-channels';
import GroupCreateExalus from '../integrations/exalus/modules/group/create';
import GroupEditExalus from '../integrations/exalus/modules/group/edit';
import GroupListExalus from '../integrations/exalus/modules/group/group-list';
import GroupSortExalus from '../integrations/exalus/modules/group/group-sort';
import ActionCreateNameIconLavva from '../integrations/lavva/modules/action-create/pages/name-icon';
import ActionCreateTaskListLavva from '../integrations/lavva/modules/action-create/pages/task-list';
import ActionCreateTaskTypesLavva from '../integrations/lavva/modules/action-create/pages/task-types';
import ActionCreateTaskVariantsLavva from '../integrations/lavva/modules/action-create/pages/task-variants';
import ActionCreateChannelSettingsLavva from '../integrations/lavva/modules/action-create/pages/channel-settings/channel-settings';
import ActionCreateDeviceVariantsLavva from '../integrations/lavva/modules/action-create/pages/devices-variants';
import ActionListLavva from '../integrations/lavva/modules/action-list';
import ChannelConfigurationLavva from '../integrations/lavva/modules/channel-configuration';
import ChannelDetailsLavva from '../integrations/lavva/modules/channel-details';
import ChannelListLavva from '../integrations/lavva/modules/channel-list';
import ChannelsVisibilityLavva from '../integrations/lavva/modules/channels-visiblity';
import DeviceListLavva from '../integrations/lavva/modules/device-list';
import DeviceDetailsLavva from '../integrations/lavva/modules/device-settings';
import GroupListLavva from '../integrations/lavva/modules/group-list';
import GroupSortLavva from '../integrations/lavva/modules/group-sort';
import GroupSortChannelsLavva from '../integrations/lavva/modules/group-sort-channels';
import GroupCreateLavva from '../integrations/lavva/modules/group/create';
import GroupEditLavva from '../integrations/lavva/modules/group/edit';

export const GroupList: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupListLavva />, Exalus: <GroupListExalus /> });
export const ActionList: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionListLavva />, Exalus: <ActionListExalus /> });
export const Dashboard: React.FC = () => useIntegrationRoute({ Lavva: <DashboardLavva />, Exalus: <div /> });
export const Groups: React.FC = () => useIntegrationRoute({ Lavva: <GroupsLavva />, Exalus: <GroupsExalus /> });
export const ChannelList: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelListLavva />, Exalus: <ChannelListExalus /> });
export const GroupCreate: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupCreateLavva />, Exalus: <GroupCreateExalus /> });
export const GroupEdit: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupEditLavva />, Exalus: <GroupEditExalus /> });
export const DeviceList: React.FC = () =>
  useIntegrationRoute({
    Lavva: <DeviceListLavva />,
    Exalus: (
      <DeviceListProvider>
        <DeviceListExalus />
      </DeviceListProvider>
    ),
  });
export const DeviceDetails: React.FC = () =>
  useIntegrationRoute({ Lavva: <DeviceDetailsLavva />, Exalus: <DeviceDetailsExalus /> });
export const ChannelDetails: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelDetailsLavva />, Exalus: <ChannelDetailsExalus /> });
export const ChannelConfiguration: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelConfigurationLavva />, Exalus: <ChannelConfigurationExalus /> });
export const ChannelsVisibility: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelsVisibilityLavva />, Exalus: <ChannelsVisibilityExalus /> });
export const GroupSort: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupSortLavva />, Exalus: <GroupSortExalus /> });
export const GroupSortChannels: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupSortChannelsLavva />, Exalus: <GroupSortChannelsExalus /> });
export const ActionCreate: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateNameIconLavva />, Exalus: <ActionCreateNameIconExalus /> });
export const ActionCreateTasks: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTaskListLavva />, Exalus: <ActionCreateTaskListExalus /> });
export const ActionTasksTypes: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTaskTypesLavva />, Exalus: <ActionCreateTaskTypesExalus /> });
export const ActionTasksVariants: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTaskVariantsLavva />, Exalus: <ActionCreateTaskVariantsExalus /> });
export const ActionDeviceVariants: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateDeviceVariantsLavva />, Exalus: <ActionCreateDeviceVariantsExalus /> });
export const ActionChannelSettings: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateChannelSettingsLavva />, Exalus: <ActionCreateChannelSettingsExalus /> });
export const ActionEdit: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateNameIconLavva />, Exalus: <ActionCreateNameIconExalus /> });
export const ActionEditTasks: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTaskListLavva />, Exalus: <ActionCreateTaskListExalus /> });
